import { normalizeBossKey } from './nikkeCatalog.js';

function text(value) {
  return String(value ?? '').trim();
}

export function isUsableBossImageSource(value) {
  const source = text(value);
  if (!source) return false;
  return /^(?:https?:\/\/|data:image\/|blob:|\/|\.\/|\.\.\/)/i.test(source);
}

export function applyBossImageFallback(bosses = [], bossImageLookup = null) {
  const rows = Array.isArray(bosses) ? bosses : [];
  const canLookup = bossImageLookup && typeof bossImageLookup.get === 'function';

  return rows.map((boss) => {
    const currentImageUrl = text(boss?.imageUrl ?? boss?.image_url);
    const key = normalizeBossKey(boss?.bossName ?? boss?.boss_name);
    const catalogBoss = canLookup && key ? bossImageLookup.get(key) : null;
    const catalogImageUrl = text(catalogBoss?.imageUrl ?? catalogBoss?.boss_image_url);

    if (isUsableBossImageSource(catalogImageUrl)) {
      return { ...boss, imageUrl: catalogImageUrl };
    }
    if (isUsableBossImageSource(currentImageUrl)) return boss;
    return { ...boss, imageUrl: '' };
  });
}
